window.loadRecaptchaV3 = function () {
    const siteKey = document.querySelector('meta[name="rv3:sitekey"]')?.getAttribute('content');
    const locale = document.querySelector('meta[name="locale"]')?.getAttribute('content');

    const url = 'https://www.google.com/recaptcha/api.js?render=' + siteKey + '&hl=' + locale;

    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = url;

    const x = document.getElementsByTagName('head')[0];
    x.appendChild(s);
};

window.reloadCaptcha = function reloadCaptcha(action, fieldName = 'g-recaptcha-response', fn = null) {
    grecaptcha.ready(function () {
        const siteKey = document.querySelector('meta[name="rv3:sitekey"]')?.getAttribute('content');

        grecaptcha
            .execute(siteKey, {
                action: action,
            })
            .then(function (token) {
                const inputElement = document.querySelector("input[name='" + fieldName + "']");
                if (inputElement) {
                    inputElement.value = token;
                }

                if (fn) {
                    fn();
                }
            });
    });
};
